import { cn } from '../../utils';

export interface AnimatedAvatarProps {
  src?: string;
  initials?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

const containerSizeStyles = {
  xs: 'h-6 w-6',
  sm: 'h-8 w-8',
  md: 'h-10 w-10',
  lg: 'h-12 w-12',
  xl: 'h-16 w-16',
};

const fontSizeStyles = {
  xs: '0.5rem',
  sm: '0.625rem',
  md: '0.75rem',
  lg: '0.875rem',
  xl: '1rem',
};

export function AnimatedAvatar({ src, initials, size = 'md', className }: AnimatedAvatarProps) {
  return (
    <div
      className={cn(
        'relative inline-flex items-center justify-center rounded-full',
        'border-2 border-primary-500',
        containerSizeStyles[size],
        className
      )}
    >
      {src ? (
        <img src={src} alt="Avatar" className="h-full w-full rounded-full object-cover" />
      ) : (
        <div
          className="flex h-full w-full items-center justify-center rounded-full bg-primary-100 font-medium text-primary-700"
          style={{ fontSize: fontSizeStyles[size] }}
        >
          {initials?.slice(0, 2).toUpperCase() || '?'}
        </div>
      )}
    </div>
  );
}
